import type { CadetParser } from './CadetParser';
import { Directive } from './Directives';
import { Item } from './Item';
import { Statement } from './Statements';

/**
 * Pulled out of CadetParser to avoid runtime cycles between CadetParser and Statements/Directives.
 */
export function parseItem(p: CadetParser): Item | undefined {
  p.consumeBreaks();
  try {
    const stmt = Statement.parseStatement(p);
    if (stmt) {
      return stmt;
    }
    const dir = Directive.parseDirective(p);
    if (dir) {
      return dir;
    }
    if (p.isEOT) {
      return undefined;
    }
    throw p.error('Syntax error', p.current.end);
  } catch {
    p.consumeUntilBreak();
  }
  return undefined;
}
